import React from 'react';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@material-ui/core/styles';
import MuiTheme from 'components/MuiTheme';
import classes from './InputControl.module.scss';

const InputControl = ({ ...props }) => (
  <ThemeProvider theme={MuiTheme}>
    <div className={classes.inputControlContainer}>
      <TextField {...props} fullWidth />
    </div>
  </ThemeProvider>
);

export default InputControl;
